import React from "react";
import {Header} from "semantic-ui-react";

const flexInlineStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 0 1em"
};

const YourCosts = ({cost, employerContribution, formattedCostPayment, strings}) => (
    <>
        {!!employerContribution && <div style={flexInlineStyles}>
            <b className="smaller neutral600Text">{strings.employerContribution}</b>
            <span className="primaryHeaderColor"><b>${employerContribution}/{formattedCostPayment}</b></span>
        </div>}
        {!!cost && <div style={flexInlineStyles}>
            <b className="primaryHeaderColor">{strings.yourCost}</b>
            <Header as="h4" style={{margin: 0}}><b>${cost}</b>/{formattedCostPayment}</Header>
        </div>}
    </>
);

export default YourCosts;
